import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import Home from "./pages/Home";
import Founder from "./pages/Founder";
import BasketballCamp from "./pages/BasketballCamp";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/founder" element={<Founder />} />
          <Route path="/basketball-camp" element={<BasketballCamp />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Footer />
        <Toaster
          position="top-center"
          richColors
          toastOptions={{
            style: {
              fontFamily: "Manrope, sans-serif",
              borderRadius: 0,
              border: "1px solid #E9ECEF",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
